import type { Dispatch, ReactNode, SetStateAction } from "react";
import { createContext, useContext, useState } from "react";

import type { ShareContentUnlocked } from "scmp-app/pages/article/types";

type PaywallMap = Record<string, boolean>;
type PaywallContainerIsDomChangedMap = Record<string, boolean>;

type ContextValue = {
  paywallIsDomChangedMap?: PaywallContainerIsDomChangedMap;
  paywallMap?: PaywallMap;
  setPaywallIsDomChangedMap?: Dispatch<SetStateAction<PaywallContainerIsDomChangedMap>>;
  setPaywallMap?: Dispatch<SetStateAction<PaywallMap>>;
  shareContentUnlocked?: ShareContentUnlocked;
};

const PaywallCheckerContext = createContext<ContextValue>({});

export type Props = {
  children?: ReactNode;
  shareContentUnlocked?: ShareContentUnlocked;
};

export const ArticlePaywallCheckerProvider: React.FunctionComponent<Props> = ({
  children,
  shareContentUnlocked,
}) => {
  const [paywallMap, setPaywallMap] = useState<PaywallMap>({});
  const [paywallIsDomChangedMap, setPaywallIsDomChangedMap] =
    useState<PaywallContainerIsDomChangedMap>({});

  return (
    <PaywallCheckerContext.Provider
      value={{
        paywallIsDomChangedMap,
        paywallMap,
        setPaywallIsDomChangedMap,
        setPaywallMap,
        shareContentUnlocked,
      }}
    >
      {children}
    </PaywallCheckerContext.Provider>
  );
};
ArticlePaywallCheckerProvider.displayName = "ArticlePaywallCheckerProvider";

export const usePaywallCheckerContext = () => useContext(PaywallCheckerContext);
